'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Styles = require("../styles");
var Tile_1 = require("./Tile");
var Utils = require("../utils/MinefieldUtils");
var Minefield = /** @class */ (function (_super) {
    __extends(Minefield, _super);
    function Minefield(props) {
        var _this = _super.call(this, props) || this;
        _this.timeoutId = null;
        var minefieldData;
        minefieldData = Utils.generateMinefield(_this.props.gameSeed, _this.props.dimensions, _this.props.numMines);
        _this.state = {
            minefield: minefieldData.minefield,
        };
        _this.props.onValidTilesRevealed(minefieldData.numRevealed);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        _this.handleLeftClick = _this.handleLeftClick.bind(_this);
        _this.handleRightClick = _this.handleRightClick.bind(_this);
        _this.handleLeftRightClick = _this.handleLeftRightClick.bind(_this);
        _this.computeHtmlDimensions = _this.computeHtmlDimensions.bind(_this);
        _this.calcTileMaxEdgeLength = _this.calcTileMaxEdgeLength.bind(_this);
        return _this;
    }
    /**
     * Called when a mouse up event happens on a Tile.
     */
    Minefield.prototype.onMouseUp = function (tileIndex, releasedButtonCode, buttonsCode) {
        if (this.props.gameEnded) {
            return;
        }
        var timeoutDuration = 500;
        if (releasedButtonCode === 0 && buttonsCode === 0) {
            if (this.timeoutId === null) {
                this.handleLeftClick(tileIndex);
            }
            else {
                global.clearTimeout(this.timeoutId);
                this.timeoutId = null;
                if (this.state.minefield[tileIndex].revealed) {
                    this.handleLeftRightClick(tileIndex);
                }
            }
            return;
        }
        if (releasedButtonCode === 0 && buttonsCode === 2) {
            this.timeoutId = global.setTimeout(this.handleLeftClick, timeoutDuration, tileIndex);
            return;
        }
        if (releasedButtonCode === 2 && buttonsCode === 0) {
            if (this.timeoutId === null) {
                this.handleRightClick(tileIndex);
            }
            else {
                global.clearTimeout(this.timeoutId);
                this.timeoutId = null;
                if (this.state.minefield[tileIndex].revealed) {
                    this.handleLeftRightClick(tileIndex);
                }
            }
            return;
        }
        if (releasedButtonCode === 2 && buttonsCode === 1) {
            this.timeoutId = global.setTimeout(this.handleRightClick, timeoutDuration, tileIndex);
            return;
        }
    };
    /**
     * Handles a left mouse button click on a tile.
     */
    Minefield.prototype.handleLeftClick = function (tileIndex) {
        if (this.state.minefield[tileIndex].revealed ||
            this.state.minefield[tileIndex].hasFlag) {
            return;
        }
        var newMinefield = this.state.minefield;
        var tilesToReveal = Utils.calcTilesToReveal(newMinefield, tileIndex, this.props.dimensions);
        var numNonMineTilesRevealed = tilesToReveal.length;
        tilesToReveal.forEach(function (index) {
            newMinefield[index].revealed = true;
            if (newMinefield[index].hasMine) {
                numNonMineTilesRevealed--;
            }
        });
        this.setState({
            minefield: newMinefield,
        });
        if (newMinefield[tileIndex].hasMine) {
            this.props.onExplosion();
        }
        if (numNonMineTilesRevealed > 0) {
            this.props.onValidTilesRevealed(numNonMineTilesRevealed);
        }
    };
    /**
     * Handles a right mouse button click on a tile.
     */
    Minefield.prototype.handleRightClick = function (tileIndex) {
        if (!this.props.flagsEnabled ||
            this.state.minefield[tileIndex].revealed) {
            return;
        }
        var newMinefield = this.state.minefield;
        newMinefield[tileIndex].hasFlag = !newMinefield[tileIndex].hasFlag;
        this.setState({ minefield: newMinefield });
        this.props.onFlagsChanged((newMinefield[tileIndex].hasFlag ? 1 : -1));
    };
    /**
     * Handles a left + right mouse button click on a tile.
     */
    Minefield.prototype.handleLeftRightClick = function (tileIndex) {
        var _this = this;
        var adjacentIndexes = Utils.findTileIndexes(this.props.dimensions, tileIndex, [[-1, -1], [-1, 0], [-1, 1], [0, -1], [0, 1], [1, -1], [1, 0], [1, 1]]);
        var numFlags = 0;
        adjacentIndexes.forEach(function (index) {
            if (_this.state.minefield[index].hasFlag) {
                numFlags++;
            }
        });
        if (numFlags < this.state.minefield[tileIndex].numAdjacentMines) {
            return;
        }
        adjacentIndexes.forEach(function (index) {
            _this.handleLeftClick(index);
        });
    };
    /**
     * Calculates the width and height of the div#minefield HTML element.
     */
    Minefield.prototype.computeHtmlDimensions = function () {
        var minViewportDimension = Math.min(this.props.viewport.width, this.props.viewport.height);
        var paddingPerSide = parseFloat(Styles.app.padding) / 100 *
            minViewportDimension;
        var appDimensions = {
            width: parseFloat(Styles.app.minWidth) - 2 * paddingPerSide,
            height: parseFloat(Styles.app.minHeight) - 2 * paddingPerSide,
        };
        var tempAppWidth = parseFloat(Styles.app.maxWidth) / 100 *
            this.props.viewport.width - 2 * paddingPerSide;
        if (tempAppWidth > appDimensions.width) {
            appDimensions.width = tempAppWidth;
        }
        var tempAppHeight = parseFloat(Styles.app.maxHeight) / 100 *
            this.props.viewport.height - 2 * paddingPerSide;
        if (tempAppHeight > appDimensions.height) {
            appDimensions.height = tempAppHeight;
        }
        var gameHeightReMatches = Styles.game.height
            .match(/^calc\((\d+)% - (\d+)px\)$/i);
        var gameDimensions = {
            width: appDimensions.width * parseFloat(Styles.game.width) / 100,
            height: appDimensions.height * parseFloat(gameHeightReMatches[1]) / 100 -
                parseFloat(gameHeightReMatches[2]),
        };
        var minefieldHeightReMatches = Styles.minefield.height
            .match(/^calc\((\d+)% - (\d+)px\)$/i);
        return ({
            width: Math.floor(gameDimensions.width * parseFloat(Styles.minefield.width) / 100),
            height: Math.floor(gameDimensions.height * parseFloat(minefieldHeightReMatches[1]) / 100 -
                parseFloat(minefieldHeightReMatches[2])),
        });
    };
    /**
     * Calculates the maximum length for each Tile's edge (in px).
     */
    Minefield.prototype.calcTileMaxEdgeLength = function () {
        var minefieldDimensions = this.computeHtmlDimensions();
        return (Math.min(Math.floor(minefieldDimensions.width / this.props.dimensions.cols), Math.floor(minefieldDimensions.height / this.props.dimensions.rows)));
    };
    Minefield.prototype.componentWillUnmount = function () {
        if (this.timeoutId !== null) {
            global.clearTimeout(this.timeoutId);
        }
    };
    Minefield.prototype.render = function () {
        var _this = this;
        var tileMaxEdgeLength = this.calcTileMaxEdgeLength();
        var tiles = [];
        this.state.minefield.forEach(function (tileConfig, index) {
            tiles.push(React.createElement(Tile_1.Tile, { key: index, index: index, revealed: (_this.props.gameEnded ? true : tileConfig.revealed), hasMine: tileConfig.hasMine, hasFlag: tileConfig.hasFlag, numAdjacentMines: tileConfig.numAdjacentMines, lastInRow: (index + 1) % _this.props.dimensions.cols === 1, maxEdgeLength: tileMaxEdgeLength, onMouseUp: _this.onMouseUp }));
        });
        return (React.createElement("div", { id: 'minefield', style: Styles.minefield }, tiles));
    };
    return Minefield;
}(React.Component));
exports.Minefield = Minefield;
//# sourceMappingURL=Minefield.js.map


//////////////////
// WEBPACK FOOTER
// ./src/js/components/Minefield.js
// module id = 36
// module chunks = 0